export const fetchLoginUrl = `/drivers/login`;
export const fetchCellphoneGetCodeUrl = `/cellphones/validation`;
export const fetchEmailGetCodeUrl = `/emails/validation`;
export const fetchCellphoneValidateCodeUrl = `/cellphones/code`;
export const fetchEmailValidateCodeUrl = `/emails/code`;
export const fetchSignupUrl = `/drivers/new`;
export const fetchLoginWithFBUrl = `/drivers/facebook`;
export const fetchPasswordRecoveryUrl = `/drivers/resetpassword`;
